import ModelUtil from '@leverege/model-util';
import { ns } from '@leverege/i18n';
const TYPE = 'graph.scale.time';
const {
  t
} = ns('ui-attributes-graphs.models.TimeScaleModel');
function create(extend) {
  return {
    type: TYPE,
    nice: false,
    clamp: false,
    reverse: false,
    get label() {
      return t('label');
    },
    visxScaleType: 'time',
    tickDensity: 50,
    ...extend
  };
}
export default {
  create,
  TYPE,
  ...ModelUtil.createAllValue('nice'),
  ...ModelUtil.createAllValue('clamp'),
  ...ModelUtil.createAllValue('reverse'),
  ...ModelUtil.createAllValue('tickDensity'),
  get name() {
    return t('name');
  }
};